export default "__VITE_ASSET__Dd5Eqmx4__"